import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCloud = () => {
  return (
    <g>
      <path d="m13.6689 8.2637a5.3086 5.3086 0 1 0 -10.3534-2.305 4.2991 4.2991 0 0 0 1.0678 8.4656h8.3877a3.1445 3.1445 0 0 0 .8979-6.1606zm-.8979 4.6606h-8.3877a2.8079 2.8079 0 1 1 .7944-5.502.75.75 0 0 0 .4229-1.4394 4.2852 4.2852 0 0 0 -.7358-.14 3.8234 3.8234 0 1 1 6.1166 4.001.75.75 0 1 0 .959 1.1533 5.3486 5.3486 0 0 0 .7949-.8193 5.3688 5.3688 0 0 0 .3472-.5286 1.6523 1.6523 0 0 1 -.3116 3.2752z" />
    </g>
  );
};

export default withIcon(IconCloud);
